var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.get('systems@ApiKey'))?_c('div',{staticClass:"content-custom-pj"},[_c('div',[_c('h4',[_c('v-icon',{staticClass:"icon-custom1",attrs:{"name":"edit"}}),_vm._v(" Round Ward")],1),_c('div',[_c('DoctorSumWard')],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }